exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mobile-transport-filter[data-v-1695a5a1]{margin-top:10px;padding:15px;background-color:#f8f9fa;border-radius:5px}", ""]);

// exports
